import { useEffect, useRef } from 'react';

import { useAuthStore } from '@/features/auth/model/auth-store';

import { trackingService } from '@/shared/api/tracking-service';
import { getStoredDubClickId, initDubTracking } from '@/shared/lib/dub-tracking';
import { logger } from '@/shared/lib/logger';

/**
 * Hook to handle DUB click tracking
 * Extracts dub_id from URL on mount and sends to backend when user is authenticated
 */
export const useDubTracking = () => {
  const hasTracked = useRef(false);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  useEffect(() => {
    // Always extract and store dub_id from URL if present
    initDubTracking();
  }, []);

  useEffect(() => {
    // Only send tracking when user is authenticated and hasn't been tracked yet
    if (!isAuthenticated || hasTracked.current) return;

    // Get stored dub_id (either just extracted or from previous visit)
    const storedDubClickId = getStoredDubClickId();

    // Send to backend if we have a click ID
    if (storedDubClickId) {
      trackingService
        .sendTracking({ dubClickId: storedDubClickId })
        .then(() => {
          logger.info('DUB tracking sent successfully', {}, { dubClickId: storedDubClickId });
          hasTracked.current = true;
        })
        .catch((error) => {
          logger.error('Failed to send DUB tracking', {}, { error, dubClickId: storedDubClickId });
        });
    }
  }, [isAuthenticated]);
};
